import * as O from "fp-ts/Option";
import { PendingData } from "lib/at-data/AsyncData";
import { AssetsInsightsState } from "./state";

export const initialState: AssetsInsightsState = {
  insights: PendingData(O.none),
};
